export default {"src":"/_next/static/media/left-arrow.1d5a986e.svg","height":17,"width":10};